import { ColorEnum } from "./ColorEnums";

// type StatusTypes = { [K in StatusKey]: {
//     id: K,
//     color: any,
//     title: string,
// } };

// type StatusKey = keyof typeof ActiveStatusEnum | LicenseStatusEnum | BillingStatusEnum;

export enum ActiveStatusEnum {
    ALL = 0,
    ACTIVE = 1,
    INACTIVE = 2,
}
export const ActiveStatus = {
    [ActiveStatusEnum.ALL]: {
        id: ActiveStatusEnum.ALL,
        color: ColorEnum.GRAY,
        title: "All"
    },
    [ActiveStatusEnum.ACTIVE]: {
        id: ActiveStatusEnum.ACTIVE,
        color: ColorEnum.GREEN,
        title: "Active"
    },
    [ActiveStatusEnum.INACTIVE]: {
        id: ActiveStatusEnum.INACTIVE,
        color: ColorEnum.RED,
        title: "Inactive"
    },
}

export enum LicenseStatusEnum {
    ALL = 0,
    USED = 1,
    UNUSED = 2,
}

export const LicenseStatus = {
    [LicenseStatusEnum.ALL]: {
        id: LicenseStatusEnum.ALL,
        color: ColorEnum.GRAY,
        title: "All"
    },
    [LicenseStatusEnum.USED]: {
        id: LicenseStatusEnum.USED,
        color: ColorEnum.RED,
        title: "Used"
    },
    [LicenseStatusEnum.UNUSED]: {
        id: 2,
        color: ColorEnum.GREEN,
        title: "Unused"
    },
}

export enum BillingStatusEnum {
    ALL = 0,
    PAID = 1,
    UNPAID = 2,
}

export const BillingStatus = {
    [BillingStatusEnum.ALL]: {
        id: BillingStatusEnum.ALL,
        color: ColorEnum.GRAY,
        title: "All"
    },
    [BillingStatusEnum.PAID]: {
        id: BillingStatusEnum.PAID,
        color: ColorEnum.GREEN,
        title: "Paid"
    },
    [BillingStatusEnum.UNPAID]: {
        id: BillingStatusEnum.UNPAID,
        color: ColorEnum.RED,
        title: "Unpaid"
    },
}

